import "@fontsource/caveat/400.css";
import { canvasAlsPng } from "./bildVorbereiten";

/**
 * Getippten Namen als „handschriftliche“ Unterschrift setzen — in Caveat (OFL-1.1, lokal
 * gebündelt über `@fontsource/caveat`, kein Google-Fonts-Abruf). Ergebnis: PNG mit
 * durchsichtigem Hintergrund, eng um den Schriftzug geschnitten.
 */

export const HANDSCHRIFT_PX = 64;
const HANDSCHRIFT_FONT = `${HANDSCHRIFT_PX}px "Caveat", cursive`;
const RAND = 8;

export async function textAlsHandschriftPng(text: string, farbe: string): Promise<Blob> {
    const zeile = text.trim();
    if (!zeile) throw new Error("Bitte einen Namen eintippen.");
    try {
        await document.fonts.load(HANDSCHRIFT_FONT);
    } catch {
        /* Ausweichschrift ist besser als gar nichts */
    }
    const mess = document.createElement("canvas").getContext("2d");
    if (!mess) throw new Error("Canvas wird von diesem Browser nicht unterstützt.");
    mess.font = HANDSCHRIFT_FONT;
    const breite = Math.ceil(mess.measureText(zeile).width);

    const canvas = document.createElement("canvas");
    canvas.width = breite + 2 * RAND;
    canvas.height = Math.ceil(HANDSCHRIFT_PX * 1.35) + 2 * RAND;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas wird von diesem Browser nicht unterstützt.");
    ctx.font = HANDSCHRIFT_FONT;
    ctx.fillStyle = farbe;
    ctx.textBaseline = "top";
    ctx.fillText(zeile, RAND, RAND);
    return canvasAlsPng(canvas);
}
